import { Container, Box, Heading, Text, Grid, GridItem } from '@chakra-ui/react';
import OnboardingRolesForm from './OnboardingRolesForm';

export default function FooterWithOnboarding({
  onboardingRoles,
  onboardingYears,
  signUpUrl,
  theme,
}: {
  onboardingRoles: {
    icon: string;
    title: string;
    query: string;
  }[];
  onboardingYears: {
    title: string;
    value: string;
  }[];
  signUpUrl: string;
  theme: {
    green100?: string;
    green200?: string;
    green300?: string;
    blue100?: string;
    blue200?: string;
    blue300?: string;
    yellow100?: string;
    yellow200?: string;
    yellow300?: string;
    red100?: string;
  };
}) {
  return (
    <Box
      pt={{
        base: '0',
        lg: '20',
      }}
      pb={{
        base: '0',
        lg: '20',
      }}
      bgColor={{ lg: 'grey.100' }}
    >
      <Container>
        <Grid gridTemplateColumns={{ lg: '1fr 1fr' }}>
          <GridItem
            textAlign={{ base: 'center', lg: 'left' }}
            display={{ lg: 'flex' }}
            alignItems={{ lg: 'center' }}
            justifyContent={{ lg: 'center' }}
          >
            <Box maxW={{ lg: '25rem' }}>
              <Box display={{ base: 'none', lg: 'block' }} mb="6" maxWidth="10">
                <Grid w="10" gridTemplateColumns="repeat(3, auto)" gridGap="2">
                  {[theme.yellow200, theme.green200, theme.blue200].map((dot) => (
                    <GridItem key={dot}>
                      <Box w="2" h="2" bgColor={dot} />
                    </GridItem>
                  ))}
                </Grid>
              </Box>
              <Heading
                as="h3"
                fontSize={{ base: '1.5rem', lg: '2.625rem' }}
                lineHeight={{ base: '1.75rem', lg: '3rem' }}
                mt="8"
                mb={{ base: '2', lg: '6' }}
              >
                Unlock your perfect job matches today
              </Heading>
              <Text>
                <Box as="strong">Tell us a bit about yourself</Box> and get matched to roles with
                high-impact startups.
              </Text>
            </Box>
          </GridItem>
          <GridItem>
            <OnboardingRolesForm
              onboardingRoles={onboardingRoles}
              onboardingYears={onboardingYears}
              signUpUrl={signUpUrl}
              theme={theme}
            />
          </GridItem>
        </Grid>
      </Container>
    </Box>
  );
}
